export default {
    // 登录接口  /login/login 钟军
    parentLogin(params) {
        return app.http.ajax({
            method: "post",
            url: "/cs-crm/parent/login",
            params: params,
        });
    },
    // 补充个人信息 /login/login 钟军
    parentUpdate(params) {
        return app.http.ajax({
            method: "POST",
            url: "/cs-crm/parent/update",
            params: params,
        });
    },
    // 获取招生码设置
    recruitsGet(params) {
        return app.http.ajax({
            method: "GET",
            url: `/cs-crm/recruits/get?companyId=${params.companyId}`,
        });
    },
    // 招生码提交，新建商机
    recruitsSubmit(params) {
        return app.http.ajax({
            method: "POST",
            url: "/cs-crm/intention/clue/recruitsSubmit",
            params: params,
        });
    },
    // 获取校区列表
    getCampusList(params) {
        return app.http.ajax({
            method: "get",
            url: "/mall-portal/campus",
            params,
        });
    },
    // 获取年级列表
    gradelList() {
        return app.http.ajax({
            method: "get",
            url: "/cs-crm/grade/list",
        });
    },
    getCustomFieldList(params) {
        return app.http.ajax({
            method: 'get',
            url: '/cs-crm/public/customField/list',
            params,
        });
    },
    // 合同详情
    contractDetail(params){
        return app.http.ajax({
            method: 'get',
            url: '/cs-edu/public/contract/student/detail',      
            params,
        });
    },
    // 合同签署
    contractSign(params) {
        return app.http.ajax({
            method: 'POST',
            url: '/cs-edu/public/contract/student/sign',
            params,
        });
    },
    // 测评报告详情-学员端使用-【不鉴权】
    evaluationInfo(params){
        return app.http.ajax({
            method: 'get',
            url: '/cs-edu/public/evaluation/student/info',      
            params,
        });
    },
    // 测评报告趋势数据
    evaluationTrend(params) {
        return app.http.ajax({
            method: 'POST',
            url: '/cs-edu/public/evaluation/student/trend',
            params,
        });
    }
};